'use client'
import Script from 'next/script'

// Meta Pixel loader + the small tracking helpers the storefront calls.
//
// Everything is gated on NEXT_PUBLIC_META_PIXEL_ID: with no id configured the
// script never loads and every helper is a no-op, so the site behaves exactly
// as before. Set the env var (Vercel + .env.local) to switch tracking on.
//
// The `content_ids` we send are MODEL SLUGS — the same value used as `g:id` in
// /meta-feed.xml and as the /cars/[slug] route. Meta can only attribute an ad
// to a viewed vehicle while those three agree.

export const PIXEL_ID = process.env.NEXT_PUBLIC_META_PIXEL_ID || ''

/** Fire a Meta standard event; silently ignored when no pixel is configured. */
export function pixelTrack(event, params) {
    if (!PIXEL_ID) return
    if (typeof window === 'undefined' || typeof window.fbq !== 'function') return
    try {
        window.fbq('track', event, params || {})
    } catch {
        // never let analytics break a booking
    }
}

/** Base pixel + PageView. Mounted once in the root layout. Skips /confirm and
 *  /cancel, whose address carries the signed link from a booking mail — a
 *  PageView reports the page's full address. */
export default function MetaPixel() {
    if (!PIXEL_ID) return null
    return (
        <>
            <Script id="meta-pixel" strategy="afterInteractive">
                {`if(!/^\\/(confirm|cancel)\\/?$/.test(location.pathname)){!function(f,b,e,v,n,t,s)
{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
n.callMethod.apply(n,arguments):n.queue.push(arguments)};
if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
n.queue=[];t=b.createElement(e);t.async=!0;
t.src=v;s=b.getElementsByTagName(e)[0];
s.parentNode.insertBefore(t,s)}(window,document,'script',
'https://connect.facebook.net/en_US/fbevents.js');
fbq('init','${PIXEL_ID}');fbq('track','PageView');}`}
            </Script>
            <noscript>
                {/* eslint-disable-next-line @next/next/no-img-element */}
                <img
                    height="1"
                    width="1"
                    style={{ display: 'none' }}
                    alt=""
                    src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`}
                />
            </noscript>
        </>
    )
}
